var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.41666V9.91666L6.41667 8.74999",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24967 9.91667L4.08301 8.75",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 5.83332V8.74999C12.8337 11.6667 11.667 12.8333 8.75033 12.8333H5.25033C2.33366 12.8333 1.16699 11.6667 1.16699 8.74999V5.24999C1.16699 2.33332 2.33366 1.16666 5.25033 1.16666H8.16699",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 5.83332H10.5003C8.75033 5.83332 8.16699 5.24999 8.16699 3.49999V1.16666L12.8337 5.83332Z",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownloadBlue);
export default __webpack_public_path__ + "static/media/document-download-blue.1f2ccd4e33c97e1fe7acc1c07a818a81.svg";
export { ForwardRef as ReactComponent };